import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BUTTON_GROUP_DEFAULT_ORIENTATION } from './ButtonGroup.constants';
import { ButtonGroupRoot } from './ButtonGroup.styled';
// Component.
// -----------------------------------------------------------------------------
const ButtonGroup = forwardRef(({ children, orientation = BUTTON_GROUP_DEFAULT_ORIENTATION }, ref) => (_jsx(ButtonGroupRoot, { orientation: orientation, ref: ref, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map